import forOwn from 'lodash/forOwn';
//
// Holding route definitions

export const makeRoute = (route, replacement = {}) => {
	let ret = route;
	forOwn(replacement, (value, index) => {
		ret = ret.replace(':'+index, value);
	});
	return ret;
};

export const ROUTE_ROOT = '/';

export const ROUTE_GENERAL = '/general';
export const ROUTE_GENERAL_DUMPS = '/general/dumps';

export const ROUTE_MODULES = '/modules';
export const ROUTE_MODULES_CREATE = ROUTE_MODULES + '/create';
export const ROUTE_MODULES_DETAIL = ROUTE_MODULES + '/detail/:module_id';

export const ROUTE_HOUSE = '/houses';
export const ROUTE_HOUSE_CREATE = ROUTE_HOUSE + '/createData';
export const ROUTE_HOUSE_ID = ROUTE_HOUSE + '/:house_id';

export const ROUTE_ACCESS = '/access';
export const ROUTE_ACCESS_CREATE = ROUTE_ACCESS + '/createData';

export const ROUTE_PROFILE = '/profile';

export const ROUTE_SERVICE = '/services';
export const ROUTE_SERVICE_CREATE = ROUTE_SERVICE + '/new-service';
export const ROUTE_SERVICE_DETAIL = ROUTE_SERVICE + '/:service_id';
export const ROUTE_SERVICE_KFZ_ASSIGNMENT = ROUTE_SERVICE_DETAIL + '/:kfz_id';
export const ROUTE_SERVICE_ALL = ROUTE_SERVICE + '/all';
export const ROUTE_SERVICE_NOT_ASSIGNED = ROUTE_SERVICE + '/not-assigned';
export const ROUTE_SERVICE_TREE = ROUTE_SERVICE + '/:service_id?';

export const ROUTE_PARTS = '/parts';

export const ROUTE_KFZ = '/kfz';
export const ROUTE_KFZ_CREATE = ROUTE_KFZ + '/create';
export const ROUTE_KFZ_EDIT = ROUTE_KFZ + '/:kfz_id';
export const ROUTE_KFZ_MODEL = ROUTE_KFZ + '/:kfz_id/:hsn/:tsn';
export const ROUTE_KFZ_MODEL_CREATE = ROUTE_KFZ_EDIT + '/new-model';

export const ROUTE_SIGN_OUT = '/sign-out';


// WEBPACK FOOTER //
// ./src/routes/index.js